export default {
  nameIsRequired: 'Name is required',
  emailIsRequired: 'Email is required',
  passwordIsRequired: 'Password is required',
  emailOrPhoneAreRequired: 'Insert an email or phone',
  onlyNumbers: 'Only numbers are allowed in phone field',
  passwordMin8: 'Password must have at least 8 characters',
  habeasData: 'You must accept the terms and conditions agreement',
  validEmail: 'Insert a valid email',
  validPhone: 'Insert a valid phone',
  codeIsRequired: 'The sent code is required',
  newPasswordIsRequired: 'New password is required',
  confirmNewPassword: 'You must confirm your new password',
  passwordsDontMatch: 'Passwords don´t match',
  fillCorrectlyFormFields: 'Fill correctly all the form fields'
}
